import apiClient from "../../api/api";

export const RequestGetApplicantById = async(applicantId) => {
    const response = await apiClient.get(import.meta.env.VITE_APPLICANTS_BASE_URL+`/${applicantId}`)

    return response.data
}